import { render } from "./TrekListComponent.vue?vue&type=template&id=1ddd8a4a&scoped=true"
import script from "./TrekListComponent.vue?vue&type=script&lang=js"
export * from "./TrekListComponent.vue?vue&type=script&lang=js"

import "./TrekListComponent.vue?vue&type=style&index=0&id=1ddd8a4a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddd8a4a"]])

export default __exports__